import {Component, OnInit} from '@angular/core';
import {UserNotificationService} from '../../../services/user/user-notification.service';
import {UserNotification} from '../../../classes/UserNotification';
import {Page} from '../../../classes/Page';

@Component({
  selector: 'app-user-notification-list',
  styleUrls: ['./user-notification-list.component.scss'],
  templateUrl: './user-notification-list.component.html',
})
export class UserNotificationListComponent implements OnInit {

  public errorMessage: string;
  public userNotifications: UserNotification[];
  public pageNumber = 1;
  public totalElements = 0;
  public pageSizes = [10, 20, 50];
  public pageSize = this.pageSizes[0];

  constructor(private userNotificationService: UserNotificationService) {}

  ngOnInit(): void {
    this.refreshList();
  }

  refreshList(): void {
    this.userNotificationService.getAllUserNotifications(this.pageNumber - 1, this.pageSize).subscribe({
      next: (page: Page<UserNotification>) => {
        this.userNotifications = page.content;
        this.totalElements = page.totalElements;
      },
      error: (error) => this.errorMessage = error.error.error
    });
  }

  handlePageChange(event): void {
    this.pageNumber = event;
    this.refreshList();
  }

  handlePageSizeChange(event): void {
    this.pageSize = event.target.value;
    this.pageNumber = 1;
    this.refreshList();
  }

  getMinLimit(): number {
    return this.pageSize * (this.pageNumber - 1) + 1;
  }

  getMaxLimit(): number {
    const maxLimit = this.pageSize * this.pageNumber;
    return maxLimit <= this.totalElements ? maxLimit : this.totalElements;
  }

}
